import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function PlaninarskoSklonisteIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PlaninarskoSklonisteIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <polygon fill="#FFFFFF" points="70.5,72 70.5,50.2 76.6,50.2 76.6,43 50,12 23.4,43 23.4,50.2 29.6,50.2 29.6,72 22.4,72 22.4,84.4 
	77.6,84.4 77.6,72 "/>
      <path fill="#FF0000" d="M72.8,44.4v1.9h-6.2v29.5h7.1v4.8H26.2v-4.8h7.2V46.4h-6.2v-1.9L50,17.8L72.8,44.4z M56.7,75.8v-19H43.4v19
	H56.7z"/>
    </svg>
  </SvgIcon>
}

export default PlaninarskoSklonisteIcon;
